import { render, staticRenderFns } from "./arrow-next-circle.vue?vue&type=template&id=fefdf484"
import script from "./arrow-next-circle.vue?vue&type=script&lang=js"
export * from "./arrow-next-circle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports